// 引入调试工具
import { PreloadImages } from '@mshark/base';
// Reset
import '../reset';
// 适配
// import '../adapter';
import './app.css';

class BaseApp {
    constructor () {
        // 预加载相关
        this.preLoadConfig = {
            imgList: [], // 预加载图片名称列表
            imgPath: '', // 预加载图片路径
            onLoad: null
        };
    }

    launch () {
        this._preload();
    }

    // 预加载完成执行
    init () {
        console.warn('[mshark]: init请外部实现');
    }

    // 预加载
    _preload () {
        const { imgList, imgPath, onLoad } = this.preLoadConfig;

        const preLoad = new PreloadImages({
            // 预加载图片列表
            imgList: imgList.map((item) => {
                if (item.match(/http/i)) return item;

                return imgPath + item;
            }),
            // 加载完成
            onLoadEnd: () => {
                this._postload();
                this.init();
            },
            // 加载中
            onLoad: (percent) => {
                onLoad && onLoad(percent);
            }
        });
    }

    _postload () {
        document.body.className += 'dy-loading-complete';
    }
}

export default BaseApp;
